import { flightPlanFillColor } from '@utils/map/map.constants';
import { getFlightPlanBorderColor } from '@utils/map/map.utils';
import { Feature } from 'geojson';

import { FeatureTypeEnum } from '@/types/map.types';
import { AbstractFlightPlan } from '@/types/utm/flightPlan.types';

export const toFlightPlanFillFeatures = (flightPlans: AbstractFlightPlan[]): Feature[] =>
  flightPlans.map((flightPlan) => {
    const outlineColor = getFlightPlanBorderColor(flightPlan);
    return {
      type: 'Feature',
      id: `${FeatureTypeEnum.FLIGHT_PLAN}-${flightPlan.id}`,
      properties: {
        featureType: FeatureTypeEnum.FLIGHT_PLAN,
        value: flightPlan,
        fillColor: flightPlanFillColor[flightPlan.state],
        outlineColor: outlineColor,
        selectOptionLabel: flightPlan.externalId ?? flightPlan.name,
      },
      geometry: flightPlan.polygons,
    } as Feature;
  });
